import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-md-6 col-lg-6 col-xl-6 col-xxl-6" }
const _hoisted_3 = {
  key: 0,
  class: "d-inline-block position-absolute top-0 end-0 w-auto"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-danger" }, "х", -1)
const _hoisted_5 = {
  class: "col-auto",
  style: {"width":"20%"}
}
const _hoisted_6 = {
  class: "col-auto",
  style: {"width":"20%"}
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "form-label d-flex" }
const _hoisted_9 = { class: "form-check m-0" }
const _hoisted_10 = ["onUpdate:modelValue", "name"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label me-3" }, "Секция", -1)
const _hoisted_12 = { class: "form-check m-0" }
const _hoisted_13 = ["onUpdate:modelValue", "name"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label me-3" }, "Участок", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_16 = {
  key: 2,
  class: "invalid-feedback"
}
const _hoisted_17 = {
  key: 1,
  class: "col-auto",
  style: {"width":"20%"}
}
const _hoisted_18 = {
  class: "col-auto",
  style: {"width":"20%"}
}
const _hoisted_19 = {
  class: "col-auto",
  style: {"width":"20%"}
}
const _hoisted_20 = { class: "row mb-4" }
const _hoisted_21 = { class: "col-12 pt-3 border-top" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader_ui = _resolveComponent("loader-ui")!
  const _component_select_ui = _resolveComponent("select-ui")!
  const _component_form_group_ui = _resolveComponent("form-group-ui")!
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_input_ui = _resolveComponent("input-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-xl",
    title: _ctx.state.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        class: "loader",
        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"]))
      }, [
        _createVNode(_component_loader_ui, {
          "is-show": _ctx.state.loader
        }, null, 8, ["is-show"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_form_group_ui, {
              "invalid-feedback": "Выберите сотрудника",
              label: "Сотрудник",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_select_ui, {
                  "is-invalid": _ctx.state.visibleErrors && _ctx.isEmployeeIdError,
                  "item-key": "name",
                  options: _ctx.employees,
                  placeholder: "Сотрудник",
                  searchable: true,
                  values: [_ctx.state.employeeId],
                  onOnSelected: _ctx.onEmployeeSelected
                }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
              ]),
              _: 1
            })
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.items, (item, itemInd) => {
          return (_openBlock(), _createElementBlock("div", {
            key: itemInd,
            class: "row mb-4 pt-3 border-top position-relative"
          }, [
            (_ctx.state.items.length > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_button_ui, {
                    "button-class": "",
                    onClick: ($event: any) => (_ctx.deleteHandler(item, itemInd))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Выберите материал",
                label: "Материал",
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_select_ui, {
                    "is-invalid": _ctx.state.visibleErrors && _ctx.isMaterialIdError(item),
                    "item-key": "name",
                    options: _ctx.materials,
                    placeholder: "Материал",
                    searchable: true,
                    values: [_ctx.state.items[itemInd].materialId],
                    onOnSelected: (m) => _ctx.onMaterialSelected(m, itemInd)
                  }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                ]),
                _: 2
              }, 1024)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, [
                  _createElementVNode("label", _hoisted_9, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.state.items[itemInd].type) = $event),
                      class: "form-check-input",
                      name: '1' + itemInd,
                      type: "radio",
                      value: 1
                    }, null, 8, _hoisted_10), [
                      [_vModelRadio, _ctx.state.items[itemInd].type]
                    ]),
                    _hoisted_11
                  ]),
                  _createElementVNode("label", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((_ctx.state.items[itemInd].type) = $event),
                      class: "form-check-input",
                      name: '2' + itemInd,
                      type: "radio",
                      value: 2
                    }, null, 8, _hoisted_13), [
                      [_vModelRadio, _ctx.state.items[itemInd].type]
                    ]),
                    _hoisted_14
                  ]),
                  _hoisted_15
                ]),
                (_ctx.state.items[itemInd].type === 1)
                  ? (_openBlock(), _createBlock(_component_select_ui, {
                      key: 0,
                      "is-invalid": _ctx.state.visibleErrors && _ctx.isSectionIdError(item),
                      "item-key": "name",
                      options: _ctx.sections,
                      placeholder: "Секция",
                      searchable: true,
                      values: [_ctx.state.items[itemInd].sectionId],
                      onOnSelected: (s) => _ctx.onSectionSelected(s, itemInd)
                    }, null, 8, ["is-invalid", "options", "values", "onOnSelected"]))
                  : _createCommentVNode("", true),
                (_ctx.state.items[itemInd].type === 2)
                  ? (_openBlock(), _createBlock(_component_select_ui, {
                      key: 1,
                      "is-invalid": _ctx.state.visibleErrors && _ctx.isDepartmentIdError(item),
                      options: _ctx.departments,
                      placeholder: "Участок",
                      searchable: true,
                      values: [_ctx.state.items[itemInd].departmentId],
                      onOnSelected: (s) => _ctx.onDepartmentSelected(s, itemInd)
                    }, null, 8, ["is-invalid", "options", "values", "onOnSelected"]))
                  : _createCommentVNode("", true),
                (_ctx.state.items[itemInd].type === 1 ? _ctx.state.visibleErrors && _ctx.isSectionIdError(item) : _ctx.state.visibleErrors && _ctx.isDepartmentIdError(item))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Выберите значение "))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_ctx.state.items[itemInd].type === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_form_group_ui, {
                    "invalid-feedback": "Укажите конструктив",
                    label: "Конструктив"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_select_ui, {
                        "is-invalid": _ctx.state.visibleErrors && _ctx.isConstructIdError(item),
                        options: _ctx.constructs,
                        placeholder: "Конструктив",
                        searchable: true,
                        values: [_ctx.state.items[itemInd].constructId],
                        onOnSelected: (c) => _ctx.onConstructSelected(c, itemInd)
                      }, null, 8, ["is-invalid", "options", "values", "onOnSelected"])
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите количество",
                label: _ctx.getCountLabel(_ctx.state.items[itemInd].materialId),
                required: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: _ctx.state.items[itemInd].count,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.state.items[itemInd].count) = $event),
                    type: "number",
                    step: "any",
                    "is-invalid": _ctx.state.visibleErrors && _ctx.isCountError(item),
                    placeholder: "Количество"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "is-invalid"])
                ]),
                _: 2
              }, 1032, ["label"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_form_group_ui, {
                "invalid-feedback": "Укажите примечание",
                label: "Примечание"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_input_ui, {
                    modelValue: _ctx.state.items[itemInd].comment,
                    "onUpdate:modelValue": ($event: any) => ((_ctx.state.items[itemInd].comment) = $event),
                    placeholder: "Примечание"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]),
                _: 2
              }, 1024)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            (!_ctx.state.id)
              ? (_openBlock(), _createBlock(_component_button_ui, {
                  key: 0,
                  class: "btn-outline-secondary",
                  type: "button",
                  onClick: _ctx.addItem
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Добавить материал ")
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_button_ui, { "button-class": "btn-primary" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.state.btn), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["id", "title"]))
}